import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Unificar", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-17 ant-col-xl-17" }
const _hoisted_13 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_14 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_19 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_cliente = _resolveComponent("selecionar-cliente")!
  const _component_selecionar_servico = _resolveComponent("selecionar-servico")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_card = _resolveComponent("card")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Unificar Serviços",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "85%",
    centered: "",
    "wrap-class-name": "ss-modal-vendas"
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.unificarServicos && _ctx.unificarServicos(...args)))
          }, _hoisted_4)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_alert, {
                message: "",
                description: "Só é permitido um item por nota fiscal de serviço. No caso de uma venda com vários serviços serão geradas uma NFS-e para cada serviço, porém você pode unificar os serviços marcando um como principal caso desejar.",
                type: "info",
                "show-icon": ""
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_a_form_item, {
                label: "Venda",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    value: _ctx.state.venda.numero,
                    disabled: ""
                  }, null, 8, _hoisted_9)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_a_form_item, {
                label: "Data da Venda",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    value: _ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(_ctx.state.venda.dataVenda),
                    disabled: ""
                  }, null, 8, _hoisted_11)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_form_item, {
                label: "Cliente",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_cliente, {
                    "codigo-selecionado": _ctx.state.venda.codigoCliente,
                    "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.venda.codigoCliente) = $event)),
                    empresas: [_ctx.props.empresa],
                    disabled: true
                  }, null, 8, ["codigo-selecionado", "empresas"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_card, { titulo: "SERVIÇOS" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.servicos, (servico, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "ant-row"
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_a_form_item, {
                      label: "Serviço",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_servico, {
                          empresas: [_ctx.props.empresa],
                          codigoSelecionado: servico.notaFiscalServico.servicos[0].codigoServico,
                          "onUpdate:codigoSelecionado": ($event: any) => ((servico.notaFiscalServico.servicos[0].codigoServico) = $event),
                          disabled: true
                        }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, {
                      label: "Valor do Serviço",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: servico.notaFiscalServico.servicos[0].valorServico,
                          "onUpdate:valor": ($event: any) => ((servico.notaFiscalServico.servicos[0].valorServico) = $event),
                          monetario: true,
                          disabled: true
                        }, null, 8, ["valor", "onUpdate:valor"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_a_form_item, {
                      label: "ISS",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: servico.notaFiscalServico.servicos[0].impostos.valorIss,
                          monetario: true,
                          disabled: true
                        }, null, 8, ["valor"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, {
                      label: "IR",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: servico.notaFiscalServico.servicos[0].impostos.valorIr,
                          monetario: true,
                          disabled: true
                        }, null, 8, ["valor"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, {
                      label: "PIS",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: servico.notaFiscalServico.servicos[0].impostos.valorPis,
                          monetario: true,
                          disabled: true
                        }, null, 8, ["valor"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_form_item, {
                      label: "COFINS",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: servico.notaFiscalServico.servicos[0].impostos.valorCofins,
                          monetario: true,
                          disabled: true
                        }, null, 8, ["valor"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, {
                      label: "CSLL",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: servico.notaFiscalServico.servicos[0].impostos.valorCsll,
                          monetario: true,
                          disabled: true
                        }, null, 8, ["valor"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          class: "ss-margin-campos",
                          checked: servico.notaFiscalServico.servicos[0].principal,
                          "onUpdate:checked": ($event: any) => ((servico.notaFiscalServico.servicos[0].principal) = $event),
                          onChange: ($event: any) => (_ctx.alterarPrincipal($event, index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Principal")
                          ]),
                          _: 2
                        }, 1032, ["checked", "onUpdate:checked", "onChange"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            retornoRequisicao: _ctx.modalBase.retornoRequisicao,
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
          }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}